import type { ReactNode } from 'react'
import { toast as sonner } from 'sonner'

/** shadcn-style toast call, rendered by sonner (the app's only toaster). */
interface ToastInput {
  title?: ReactNode
  description?: ReactNode
  variant?: 'default' | 'destructive'
  duration?: number
}

function toast({ title, description, variant, duration }: ToastInput) {
  const show = variant === 'destructive' ? sonner.error : sonner.success
  const id = show(title ?? description, { description: title ? description : undefined, duration })
  return {
    id: String(id),
    dismiss: () => sonner.dismiss(id),
  }
}

function useToast() {
  return {
    toast,
    dismiss: (toastId?: string) => sonner.dismiss(toastId),
  }
}

export { useToast, toast }
